import { useCallback } from "react";
import { useFormAPI } from "@/widgets/classic-form/form";

export const useToggleNameExactness = () => {
    const { setFieldValue } = useFormAPI();

    return useCallback(
        (newValue: boolean) => {
            if (!newValue) {
                setFieldValue("name.givenNameExactness", {
                    isExact: false,
                    flags: { phonetic: false, similar: false, initials: false },
                });
                setFieldValue("name.surnameExactness", {
                    isExact: false,
                    flags: { phonetic: false, similar: false, soundex: false },
                });
            } else {
                setFieldValue("name.givenNameExactness.isExact", newValue);
                setFieldValue("name.surnameExactness.isExact", newValue);
            }
        },
        [setFieldValue],
    );
};
